import { SAN_FRANCISCO_HUB_PATH_IDENTIFIER } from '@/lib/constants';
import {
  createFileRoute,
  Navigate,
  redirect,
  useSearch,
} from '@tanstack/react-router';

export const Route = createFileRoute('/')({
  validateSearch: (search: Record<string, unknown>) => ({
    redirect: search.redirect as string | undefined,
    focus: search.focus as string | undefined,
    code: search.code as string | undefined,
    state: search.state as string | undefined,
  }),
  beforeLoad: ({ context }) => {
    if (context.auth.isAuthenticated) {
      throw redirect({
        to: '/$hub/archived-deals',
        params: {
          hub:
            context.auth.user?.current_hub ?? SAN_FRANCISCO_HUB_PATH_IDENTIFIER,
        },
      });
    }
  },
  component: Index,
});

function Index() {
  const search = useSearch({ from: '/' });
  return <Navigate to="/auth" search={{ redirect: search.redirect }} />;
}
